<template>
  <div class="home">
    <section>
        <header>
            <img src="@/assets/img/binance.png" alt="">
        </header>
        <div class="bgItem1Img">
            <svg width="600" height="600">
                <image x="0" y="0"
                    width="100%" height="100%"
                    xlink:href="@/assets/svg/Ribbon.svg"/>
            </svg>
        </div>
        <div class="bgItem2Img">
            <svg width="500" height="500">
                <image x="0" y="0"
                    width="100%" height="100%"
                    xlink:href="@/assets/svg/ribbon2.svg"/>
            </svg>
        </div>
        <div class="npxsxemCon">
            <div class="total">
                <div class="totalLeft">
                    <h3><div class="NPXSXEMTitle">NPXSXEM</div> <div class="luckyTitle"><span class="h3L">L</span><span class="h3U">U</span><span class="h3C">C</span><span class="h3K">K</span><span class="h3Y">Y</span></div></h3>
                    <p class="totalTitle">Total</p>
                    <h2>
                        <span>52,500,000 </span>
                        <div class="toGrab">
                            <span>NPXSXEM</span>
                            <span>to Grab</span>
                        </div>
                    </h2>
                    <div class="tradeBtn">
                        <div class="commonBtn" @click="toTradeNPXSEM">Trade NPXSEM <span class="tradeBtnicon"></span></div>
                    </div>
                    <p class="totalTitle">Activity time: </p>
                    <p class="septTitle">{{lucky.dt}}</p>
                </div>
                <div class="totalRight">
                    <img src="@/assets/img/76Ab.png" alt="">
                </div>
            </div>

            <div class="round-list" v-if="luckys.length > 1">
                <div class="round" v-for="(l, index) in luckys" :key="index" :class="checked === index ? 'round-active' : ''" @click="luckyRound(index)">Round {{ index + 1 }}</div>
            </div>

            <div class="participantsCon">
                <div class="waveImg">
                    <img src="@/assets/img/wave.png" alt="">
                </div>
                <nav>
                    <div class="luckyCombination">
                        <div class="combinationImg">
                            <img width="100%" src="@/assets/img/icon_combination@2x.png" alt="">
                        </div>
                        <div>
                            <p>Lucky Combination</p>
                            <h4>{{lucky.combination}}</h4>
                        </div>
                    </div>
                    <div class="participants">
                        <div class="participantsImg">
                            <img width="100%" src="@/assets/img/icon_participants@2x.png" alt="">
                        </div>
                        <div>
                            <p>Participants</p>
                            <h4>{{lucky.participants}}</h4>
                        </div>
                    </div>
                </nav>
            </div>
            <!-- <div class="search">
                <div class="searchInput">
                    <input type="text" @blur="animateWidth('company_name','blur')" @focus="animateWidth('company_name','focus')" :class="{'searchValCss': searchValCss}" v-model="searchVal" placeholder="Search your hash">
                    <div class="searchBtn" @click="getQueryHash">
                        <img width="100%" src="@/assets/img/icon_search@2x.png" alt="">
                    </div>
                </div>
            </div> -->
        </div>
    </section>
    <section>
        <div class="informationList">
            <div class="informationListL">
                <div class="informationListTitle">
                    <span>Match</span><span>Combination</span><span>Matching tx hash</span> <span class="hiddSpan">Prize pool (NPXSXEM)</span><span>Prize / tx hash(NPXSXEM)</span>
                </div>
                <ul>
                    <!-- <li v-for="(item, index) in winningLevelList" :key="index" @click="onLevelHash(index, item.level, item.code)" :class="{'selected': current === index}">
                        <span>{{ item.level }}</span><span>{{ item.code }}</span><span>{{ item.winner }}</span><span class="hiddSpan">{{ getThousandNum(item.prizePool) }}</span><span>{{ getThousandNum(item.prizeWinner) }}</span>
                    </li> -->
                    <li v-for="(l, index) in lucky.tables" :key="index" @click="luckyTables(index)" :class="{'selected': tableChecked === index && l.match !== '' }" >
                        <span>{{l.match}}</span><span>{{l.combination}}</span><span>{{l.hash}}</span><span class="hiddSpan">{{l.pool}}</span><span style="text-align: right; padding-right: 10px;">{{l.tx}}</span>
                    </li>
                </ul>
            </div>
            <div class="informationListR">
                <div class="informationListTitle">Winning TX hash</div>
                <ul id="homeScroll">
                    <span v-if="hashs.hashs.length < 1" class="comingSoon">No Data</span>
                    <li v-else v-for="(h, index) in hashs.hashs" :key="index">
                        <span>{{getSubStr(h.hash)}}<em class="codeVal">{{ hashs.combination }}</em> </span>
                    </li>
                </ul>
            </div>
        </div>
        <div class="activityRules">
            <h3>Activity Rules</h3>
            <div class="activityRulesText">
                <p>
                    <span>1</span>
                    <span> Each Tx Hash is valid for  7 days only.</span>
                </p>
                <p>
                    <span>2</span>
                    <span>2 Random pick of a lucky combination which consists of number (0-9) + alphabet (a-f) will be announced at the beginning of the session. The rest of the combination will be announced at the end  of the session.</span>
                </p>
                <p>
                    <span>3</span>
                    <span>To participate, traders buying NPXSXEM Tokens have to match their transaction hash with lucky combination.</span>
                </p>
                <p>
                    <span>4</span>
                    <span>Each matching Tx Hash shall be entitled to one prize only. And all Tx Hash that matches the lucky combination shall be entitled to claim from the 52,500,000 units of NPXSXEM.</span>
                </p>
                <p>
                    <span>5</span>
                    <span>Tokens given away each week. The NPXSXEM Tokens shall be distributed equally to a class of winners.</span>
                </p>
                <p>
                    <span>6</span>
                    <span>No NPXSXEM Tokens will be given out and the 52,500,000 units of NPXSXEM Tokens will not be rolled over to the giveaway the following week, if there are no transaction identifications that matches with the lucky combination for any particular week.</span>
                </p>
                <p>
                    <span>7</span>
                    <span>For more information, please visit <a class="medium" href="https://medium.com/pundix/c757ad286381">medium</a></span>
                </p>
            </div>
        </div>
        <div class="activityRules">
            <h3>How To Receive Reward</h3>
            <div class="activityRulesText">
                <p>
                    The NPXSXEM Tokens will be sent to the weekly winner(s) wallet address(es).
                </p>
            </div>
        </div>
        <div class="activityRules">
            <h3>Activity Terms And Conditions</h3>
            <div class="activityRulesText">
                <p>
                    Pundi X reserves the right to cancel or amend the activity rules at our sole discretion.
                </p>
            </div>
        </div>
        <div class="activityRules">
            <h3>Illustration, If lucky Combination: 12AB45CB</h3>
                <div class="exampleListL">
                    <div class="exampleListTitle">
                        <span>Match</span><span>Combination</span><span>Matching tx hash</span><span class="hiddSpan">Prize pool (NPXSXEM)</span><span>Prize / tx hash(NPXSXEM)</span>
                    </div>
                    <ul>
                        <li>
                            <span>8</span><span>12ab45cb</span><span>1</span><span class="hiddSpan">22,500,000</span><span>22,500,000</span>
                        </li>
                        <li>
                            <span>7</span><span>2ab45cb</span><span>5</span><span class="hiddSpan">5,000,000</span><span>1,000,000</span>
                        </li>
                        <li>
                            <span>6</span><span>ab45cb</span><span>10</span><span class="hiddSpan">5,000,000</span><span>500,000</span>
                        </li>
                        <li>
                            <span>5</span><span>b45cb</span><span>5</span><span class="hiddSpan">5,000,000</span><span>1,000,000</span>
                        </li>
                        <li>
                            <span>4</span><span>45cb</span><span>25</span><span class="hiddSpan">5,000,000</span><span>200,000</span>
                        </li>
                        <li>
                            <span>3</span><span>5cb</span><span>50</span><span class="hiddSpan">5,000,000</span><span>100,000</span>
                        </li>
                        <li>
                            <span>2</span><span>cb</span><span>100</span><span class="hiddSpan">5,000,000</span><span>50,000</span>
                        </li>
                        <li>
                            <span></span><span></span><span></span><span class="hiddSpan">52,500,000</span><span></span>
                        </li>
                    </ul>
            </div>
        </div>
    </section>
  </div>
</template>
<script>
export default {
  data () {
    return {
      luckys: [
        {
          dt: '18th October 2019 2PM (GMT+8) - 24th October 2019 11.59PM (GMT+8)',
          combination: '7995 af17',
          participants: '565',
          tables: [
            {
              match: 8,
              combination: '7995af17',
              hash: '0',
              pool: '22,500,000',
              tx: '0',
              hashs: []
            },
            {
              match: 7,
              combination: '995af17',
              hash: '0',
              pool: '5,000,000',
              tx: '0',
              hashs: []
            },
            {
              match: 6,
              combination: '95af17',
              hash: '0',
              pool: '5,000,000',
              tx: '0',
              hashs: []
            },
            {
              match: 5,
              combination: '5af17',
              hash: '0',
              pool: '5,000,000',
              tx: '0',
              hashs: []
            },
            {
              match: 4,
              combination: 'af17',
              hash: '0',
              pool: '5,000,000',
              tx: '0',
              hashs: []
            },
            {
              match: 3,
              combination: 'f17',
              hash: '0',
              pool: '5,000,000',
              tx: '0',
              hashs: []
            },
            {
              match: 2,
              combination: '17',
              hash: '25',
              pool: '5,000,000',
              tx: '200,000',
              hashs: [
                { hash: 'B7D653C957028B1C6B7EDD9B6B5E4706EE225F86232B55A9B686D3B6B60FA817' },
                { hash: 'E3CC8E1F676A5573D85BC50FD8D737B1770CD8238288A619E621A33F52A46D17' },
                { hash: '1076D722BF0AFF0991709BE7319D80668D56EA895A7871852C5125D8E20C9B17' },
                { hash: '5C9C650F70E997E498D8A42C501E6D46B9A7D6E5B7796796588B01C8A7B70717' },
                { hash: 'D4BD3963021A2A11279669553779A3E9289EF0EDBA0250C2BC0703F8A4896917' },
                { hash: 'F4026E1D0208191394F3653EFFFC549DD3D2B32D2E7527C961B7F4A9BBED3B17' },
                { hash: 'FB0B3AA40529888EBA9AB3E07DD7FB8259FF96EBA11A1772DA47701FB0D0E317' },
                { hash: 'FB55901E1C710487A5015E0B55E04FAD9A2CCB3B9046D5EC9D843C6D56B2EA17' },
                { hash: '40C4976B27E4AF77760E9FE098787670589EDCCC3CDF8C73450E1FD7E4E9A117' },
                { hash: '08A0E44F6263FAAE7310E6A89F938C1507C43CFA779FE0E20719748569F36617' },
                { hash: '7F81960D7156FB1014548593798C8D805AD4A8197C8B3D370C4E13F3FF902D17' },
                { hash: '794634B64592E505836EC6B460453CC476DCB2520F401B7578F18737AA2D1E17' },
                { hash: '178F61B4DF7A07A9F267728A5EB25B97C365404E193024CC8D73BB2D63DF4C17' },
                { hash: '7326DD3541FE34CB5ECE758D5175CAC5CBFAA6E07A5C1F128AF03FD4D23AA717' },
                { hash: '9F844AD45C04CD0B78E429034119FDE3A63149DD2B262736B02492D140F67E17' },
                { hash: '7326DD3541FE34CB5ECE758D5175CAC5CBFAA6E07A5C1F128AF03FD4D23AA717' },
                { hash: '9F844AD45C04CD0B78E429034119FDE3A63149DD2B262736B02492D140F67E17' },
                { hash: '7326DD3541FE34CB5ECE758D5175CAC5CBFAA6E07A5C1F128AF03FD4D23AA717' },
                { hash: '9F844AD45C04CD0B78E429034119FDE3A63149DD2B262736B02492D140F67E17' },
                { hash: '7326DD3541FE34CB5ECE758D5175CAC5CBFAA6E07A5C1F128AF03FD4D23AA717' },
                { hash: '9F844AD45C04CD0B78E429034119FDE3A63149DD2B262736B02492D140F67E17' },
                { hash: '7326DD3541FE34CB5ECE758D5175CAC5CBFAA6E07A5C1F128AF03FD4D23AA717' },
                { hash: '9F844AD45C04CD0B78E429034119FDE3A63149DD2B262736B02492D140F67E17' },
                { hash: '7326DD3541FE34CB5ECE758D5175CAC5CBFAA6E07A5C1F128AF03FD4D23AA717' },
                { hash: '9F844AD45C04CD0B78E429034119FDE3A63149DD2B262736B02492D140F67E17' }
              ]
            },
            {
              match: '',
              combination: '',
              hash: '',
              pool: '52,500,000',
              tx: '',
              hashs: []
            }
          ]
        },
        {
          dt: '25th October 2019 8PM (GMT+8) - 31th October 2019 11.59PM (GMT+8)',
          combination: 'f419 097d',
          participants: '652',
          tables: [
            {
              match: 8,
              combination: 'f419097d',
              hash: '0',
              pool: '22,500,000',
              tx: '0',
              hashs: []
            },
            {
              match: 7,
              combination: '419097d',
              hash: '0',
              pool: '5,000,000',
              tx: '0',
              hashs: []
            },
            {
              match: 6,
              combination: '19097d',
              hash: '0',
              pool: '5,000,000',
              tx: '0',
              hashs: []
            },
            {
              match: 5,
              combination: '9097d',
              hash: '1',
              pool: '5,000,000',
              tx: '5,000,000.00',
              hashs: [
                { hash: 'FAD53E984DE5E5C51B33F96B07AB4C20444BC2BB9700955A552DB9C59E49097D' }
              ]
            },
            {
              match: 4,
              combination: '097d',
              hash: '0',
              pool: '5,000,000',
              tx: '0',
              hashs: []
            },
            {
              match: 3,
              combination: '97d',
              hash: '12',
              pool: '5,000,000',
              tx: '416,666.67',
              hashs: [
                { hash: 'B1B082BA25900F77FF177F1C7B470FBD1B0341296EDD1CD6E59215D072F2897D' },
                { hash: '18FFA51830DAC8F178AFC153D6FDE6FDF99B1CAA06635D35FCDAA56728EE497D' },
                { hash: 'DAF2E88E1933C4250A6AC732B1C37B821A3428600CF35F3FBBE7CA554B9F897D' },
                { hash: '95C326CDF61B5C8E6FB537E12A7E8E0EC877E9967A2D79753347A5436C5C797D' },
                { hash: 'B61FD388844F7912BFA3078A79CBEE3E5E53982BF33A1527483BDE240E3E597D' },
                { hash: '7096ECFBC3D84BD73C92612A7E2F19B04ACD975B138A3DF09332E268C4D0697D' },
                { hash: '5470568E7AE7614997A5FC3C509950FD14DC45B6AF767BE86B7EF31F6921897D' },
                { hash: 'CA0DE484BF26CDE0762C1F859BB748E20266748AACE0C22B83AF42F3EFDAE97D' },
                { hash: '256120B5822E378DB13F695D75CF60320A0ECA0F4E151025B2A0F8FE48D2E97D' },
                { hash: '6512E5490FEFCB32B18FB6482E1B718CEB5E801A81FA8519E6F098D27926F97D' },
                { hash: '145BD46DFBA296AF8B7A30148036FA896F3E47F6E846A69A06A8F0EFFF27B97D' },
                { hash: '1AE9319BF57AFDDC12772D3A1B796E5D8BEA547CA54BFA1A8C629B44B6BBD97D' }
              ]
            },
            {
              match: 2,
              combination: '7d',
              hash: '178',
              pool: '5,000,000',
              tx: '28,089.89',
              hashs: [
                { hash: 'AE6958F968F71FA097C5AF9B00FE2AA23018C054D9A69485EB31FD79C3DDFD7D' },
                { hash: '37F09F13F6263B36D492917236E05C50EE67CCF7FEFD40536E7B2BE208FE067D' },
                { hash: '7C65E4DCA6BC68B7CA2DB4E7E4EB7934A83DC7A2868CE8A578F992BF8344107D' },
                { hash: 'B9FA03296EF0B05FC886D77964693C54FCF8248B2E973D39E7A8231BB80EF67D' },
                { hash: 'FC0C31BF48F1F025958D58E8AFD74E29D3E0557C0C51EE975329DB570F0EFE7D' },
                { hash: 'CADDE92E6AD778AAD62914B493776064B52402A7080A7D37FB2416F07BC3277D' },
                { hash: 'E98493EBCEC51F30EB41650D834EBDCDF8F8C37F65876CC71CD1D01A271D907D' },
                { hash: '0CA43450B309FDA6F56838C1292E8729A87E0690550F05AB3133EC96A65EA47D' },
                { hash: '9FD7F94C2D80A1B46AFFCED315E173BB2537931DBC3E1C1C62ADAB2D63140C7D' },
                { hash: '1664EA7F54F4B6C2A1538CE3971DF8C57F38CF8DE91AD824D6FCD5115E95AA7D' },
                { hash: 'C3AF25732BF56E759C903817172F122DEA6840316C6ADDD26A2E5529471E777D' },
                { hash: '6FB246DFD846F1760D5B9AC9A5089FAF307F608290B90C9ABE3E72AB5253437D' },
                { hash: '8309D7966267871DAED56E8E6774B4BE8280CBDC94EF2CDA13118CE957CA527D' },
                { hash: 'DCB650CFB0005C6DE497564B7CFE00D5BA6E230AD8E0954F3345D85FC51F3F7D' },
                { hash: '0884C8553DBC13A5FEA38E9008EC2A4C3D7E35728357AE063A33A4C2AF9CBF7D' },
                { hash: 'CDE82C26C0BFD18EA40999474C64907FE63AC95FF0142A6C175C88254F3B627D' },
                { hash: 'E7742DD89BE4F71BD71EF90D649431C4D65CD814204CD7343B14F0B34BA05B7D' },
                { hash: '6C34A2A2CAE93278E535DE03ED80DAD7275219027DC17B22BF6B48EEFAA7CA7D' },
                { hash: '901C4856A9571992381CC88CA9559926B0D62E6F48018238C5097942AD49977D' },
                { hash: '7A58DAB88C3BDEB5EAC6D13F3E462893BE3208972AB875A9E2F1C0873DCCFB7D' },
                { hash: '59763741AD4E40CE2C6C0BBB99100A0FBC10D7C2DB5378A60D901388733F947D' },
                { hash: '32CCC7892A1C6DFAD06BA6618D008FAC5BC0D12C2A604BA3BF8379209CA10D7D' },
                { hash: '404813A0003373A826437DBC5E0558FA5758927C4D6D68BB8D18A4AB4742257D' },
                { hash: '6DF646D2C883282C943A5D5118ED2632308CFE7083C44889C84F0BA82418F47D' },
                { hash: 'DEA87983E9290A11557E1059C4F39A7E691A68802FDF6B884ADCF457D14F877D' },
                { hash: '37BF6E631655F598A0ECA55C6F780D1DF8699F9884017FC68CA1035C9EC34F7D' },
                { hash: 'F3EE522D21520A40938B9BE70A42389F8BB299C7BADEBA32511A36C97B9DD27D' },
                { hash: 'B6EE81EEC3CD78A1EF57F959DDB3F11439D826DDFB554DC68DED3F34CF05D07D' },
                { hash: 'BB9CD343B87A2F8FF1D43D633F557F013DD1CE17ADDBE3FFFA9B0E5FF91CB47D' },
                { hash: '618281E84702456E78B08851C7AF671EB342E54976D14F78CA0781B15F3EA07D' },
                { hash: 'E3DC333D5BF6C215BFC8BA5352AF6E62DC8F2C706CA024C1C8952506EE54687D' },
                { hash: '21257C5369CB9B3C0EA502D4E36A8BF88EFC2C766AD8942E893E147DE9B2FE7D' },
                { hash: '15B245ED83F97651EF178EAAD483937DAE0D42102FEE6286A246893454046B7D' },
                { hash: '4971C98571032AA785CF24C788E0F506E675463D69CDF3B69B1DFA2F36CD517D' },
                { hash: '0B40A33AA7F98A588C3F6A5492BBBC996FBB7C0A9783555B77A8D7A9FB92CC7D' },
                { hash: '68FE6B59C485F9F96C49C73C138EB90754BDADC2C41784313CABAC69050FE57D' },
                { hash: '51AFC9AE3F25D0A4E4BF12473ED14C1DA11D5C7EF003C396F60DF1F82008DF7D' },
                { hash: '77ED87A1D6AE17565D12085FFA93CCF64C1E4C25CA86D90EDEC3D157D0E2887D' },
                { hash: '501AD307B99BC6808ED23799D6AA93D13C568E28872D36EF07C7DB8546BC9D7D' },
                { hash: 'D7CAB824482F06C352CAAB25C4BE9B10891C95C193EDA6794F18C3AB6450707D' },
                { hash: 'E0726F325AA7AF8DE969E748CE0F2BD65DEAAB1E642F5AA79F72C7983F1AB37D' },
                { hash: '95DAC5338E9FC90C972B7020E455D3F11CFD4A84B1398889FF5B2F5C7FD5EE7D' },
                { hash: 'DCCAF7EE7307B743278439AC89D4FCEF0DEBD375C7103DC3186C078FB9B54F7D' },
                { hash: '7085389E65DF5A117170BFBB53574CB03F0F3B8486313B981A80991F40AFC27D' },
                { hash: '982DCF1FED4189F3F345BC04A2880AAE39EACC43B05CE52CAC3CB258FD43277D' },
                { hash: '46EC0C113A5BE6117E41FEB6B2C674DA0BE1608BB33510CD8F479A76F067417D' },
                { hash: '8D2764D3C7FEA57C9E47716F2AE0F102E6B7F551394470EABAEB13257C2AA87D' },
                { hash: 'E266A90B66303106EA27C052E9F6203DE192C4557DFBFF0436EFA8C7C52FC37D' },
                { hash: 'A76A3B67C73947A64806BCC2C0812A223A346ED299B46E986AB3F5A20BDE7B7D' },
                { hash: 'D97F2609EF50BBE324855AFF8648C06A56B48DDB31C8545517F72C3D7C23A47D' },
                { hash: 'DA0A57B7E541FF62F814C383814E8879C6F1F517C67CA0F06B25A8974267707D' },
                { hash: '23712A8B50CD231DEDAB42222AD4EDE4016455F1D1398BE33A7B3AE8BC61907D' },
                { hash: 'EF712255E53F9FAC1C1A5846246E35DDB2E5F2D7E0F92FEAF8B2B1EECEA7FF7D' },
                { hash: '810327D9C136A4E7821C8ED0F676D4590CE238080562650AD1D6FDC5790F547D' },
                { hash: '47131C6D5B7206D5945AAC9A785833D89B20D989F605946054433D1075C8CB7D' },
                { hash: '396832C2DA32BAB1E7FF3001818E2CF3A46336D4EC18AFF6B3B82B53721E617D' },
                { hash: 'BEABDE68C15CC22B1517EE3DA586FC761768D6003F92DE0656C8E468912BCD7D' },
                { hash: 'FEECDFCBA036B1A46E9178DF972F221BEA67F0DC217F1FA09AB3600C5438947D' },
                { hash: '901D443F522C775BAA7A56B3631EB82ED129F8459C083E12066A1D4B12723F7D' },
                { hash: 'F3C009559133C30EA488EAAB0A72FED483A00AC381D53FFB4EF285AD230BDA7D' },
                { hash: '844320B0A5DE587BC6B416BCF7371507B8C206A9951BBA7BAD422881FF806C7D' },
                { hash: 'E1EA4AF0BBC1E40D679C3475C25B0738C0930B32581AD0CD9E5B2F249A69057D' },
                { hash: 'E279DEF96E7B6BABAC285BD160806856B222096F45D02846213C8979BD38D37D' },
                { hash: '275C2259464129C69DBEF3EF04CED9132620CF652623510238C21AE70382207D' },
                { hash: 'C6245000BA7EDED365873F58261764ED488B849E53E50E0CE3535A15129CBB7D' },
                { hash: '758B9C3637E2C4EF88D1EE695917C3B5F6D06F6902109BAFAF48FEC313CCC47D' },
                { hash: 'BF00FC7816F53061A44ECD8EF6E3B642E52ECAF2C374C37076E113348D0A8C7D' },
                { hash: '291DDBF69EE9C3050A500C07C0B05F8A89594524372FB4548A8BA04D7E71587D' },
                { hash: '2BC1B49BBA58A895AF4B121E9653DE91383E67A85A68382C007FD7E70104D07D' },
                { hash: '2F25C309DEDC02548EF2B7BE3330107E4C83A3B77D7FBD5980B8763B73A1C17D' },
                { hash: '995351888BDE2E389596228FA72D85C7F3B71CAE04EB71F20A1CD685FCA72C7D' },
                { hash: '0DE98FEA4294100C0190404D73D168717D338A71189D75A0F2A0A14EA23C837D' },
                { hash: '9DAB981C946F8D12D291234FB67C057161DBA2036C87CCE0674FA05BEC1C317D' },
                { hash: '7FB354B20C518F9877D03EF5B0857F755FD84EC8DF8EA71183A561D04651C77D' },
                { hash: '71C8142CD367055C678050F6A47769C8A31CD125EE344B0BCA3F1284D9696C7D' },
                { hash: '29B792CD535055DFD432843ADEF27EDC5A97820A81858393C78D67D3B479CD7D' },
                { hash: '361448373D83E7D9583EC20F14EBFD5A87CE01BD4508166016DE8742FD13DB7D' },
                { hash: 'A05F72C836DA221312E2D299A5B6731A332EA984A6306F44AD23834CF51A957D' },
                { hash: 'B46FD788C55ED5CE60FEF2522AEDF7D5EC396380168104FC462D3FE59EA2C17D' },
                { hash: '2CE9C224209FD8E35B9EF1283C432F5B478E8CC20DA7DC693DCC2E7C0820C17D' },
                { hash: '101076F8052918152E851ADCDE7BEA24C6FEE0B782951A610CBFCC3DBC78707D' },
                { hash: 'B2FAE28C560BA792B904398C9843F481F0841B233B98764336DF2F24D834D77D' },
                { hash: 'CE131A09E6540B1E513D2E3B957DC6986981153099B47AB5C5E4B3124A59017D' },
                { hash: '425D7233C97742F95439068264A016AAB5CE47DE12236A6B3D135F13CBC3B17D' },
                { hash: 'E6A5770330F2AD7C7B88AC90356776254D7E12132DAF70CDE3DA04283C37907D' },
                { hash: '6CCBB4C02D2BBE212C88D9B4727E919A07DF0B2F772FDAD8C85FA882B3C4907D' },
                { hash: '8FB9E03BC99FB3E74A0E1C0F401739DE6F392671133AABCB8679B39A964A9C7D' },
                { hash: '181AF6C048987B2D3BF5D12AF3637AC668ABAD192739BFBA76A7E8CCA168A77D' },
                { hash: 'D22907ECD09F0E5426D252D4F054A3ABE75BC756CF6413FA7DC0DEE455D0537D' },
                { hash: '35BED1498787E7B8890574F29A144A59018277DD387C6919F03A0EC732F9447D' },
                { hash: '2C394519B0277A73622125149991E79CA39438106057B5C011DC2857DADFC17D' },
                { hash: '5D6E2046F94FF8AEDA7F3B666A5673B887DDBE509B84C9BB8E6C2FDD9106BB7D' },
                { hash: '2A95A566E17A29085D1B32B9F1A731768F721802516BA80E0088F531E2B1377D' },
                { hash: 'F8A5073341AE89AA3A242858D7DB87DE1864957D099062F5D9133CE7D1A6AC7D' },
                { hash: 'EF96BA30A3B8FDA897096C060382AC973EB268E7BDEDEA8AB27EF8AE0A499A7D' },
                { hash: '0CC3450B113712AD80B34F5DEDFAE96D13EEED5A5EBBA5A00BD96AB98BF04E7D' },
                { hash: '816638CF029F41694019BB70457027CCF87FED56EABB488F1BD9C27320B6FB7D' },
                { hash: '4AC78E6418B85352A7485EB499A6086A379D203BAC58F5A5E07CC0CB5924177D' },
                { hash: '898E62F4690F7620AD2C705B136FE4DC0B45A188D14B02552B9B47297632D27D' },
                { hash: '3858568A5AA419952B60EE143949B48C5AAD3F7BD526FDD7C0903411EEC2DC7D' },
                { hash: 'E0CC6D89360B6D410EC9505C253A529A402D56FF2744BEC6D31087C2B2C80B7D' },
                { hash: '2A237B25C6CFA0D1B930C5281A2108C1141F3BE6D5BD2337848E902FF938E87D' },
                { hash: '365E53AF0D3B4A81378D4A33F6F88980F1DF2E1AD64CB377B898C9FBC5EA2C7D' },
                { hash: '3E7FA0683A1634311C1EF34ED18F710B26263FDAF6A7BE7285385B6DC66F5B7D' },
                { hash: '6FCE6323BF50EDD7E01E938FF119B7FF5F08A60D670D5C311BCC024F5D5AB47D' },
                { hash: 'D162FCD38A2E70C8188A17DCC6CFEEDE3C0FCB6C61FBFD3DEB8152D4D337DC7D' },
                { hash: '6274D592ECB671CB6A6E9D73AB4951D2A4FE89D1B46920B40677CA66764BFB7D' },
                { hash: '0D07DA48FDF0DE81258A94BEC5E8F3334446D15D28D51ABA1AC898F7FF667D7D' },
                { hash: '957F04E7C74019D0943F278655E4CBEFCF73AF437EBC6EB271AA2D701EF98B7D' },
                { hash: 'AB7415ED3635419A0CC6DC6D7204F2499802953DB3272A125407B319E13CFC7D' },
                { hash: '6C99227D3DF9166248EF6023500D7AA20BEFC6AA8004644BB4E249B199E1AC7D' },
                { hash: '91E70957A99A9B567FCCB9A75219647D635C3B4B6CA89908AF2E9C6885D4DB7D' },
                { hash: '5FCB63E6658BB47A6DD8B0C75E81CB643A596767FEA07FCE095C2E0BD8ED2B7D' },
                { hash: 'ABEA0DFB4498502B4EE0D313C9C7D50115FB75EAF9A3603DE2E770F455A9107D' },
                { hash: 'F65E525B1565A515C28389B89A9C7725CF82D2C1EB17706A9EA88A25470C2E7D' },
                { hash: '6129EDE0EC05890F24BBA0DB3C499E2308904CFE4DC332C499B29F7A9B7E4A7D' },
                { hash: '29088A5600493C202264F8271C419D1E74014DD7505422EC34709F7B41DC987D' },
                { hash: '891246FC9CD1810F5653C929A828A7B2220A1FB698B68E2DBFFEC4102F82F37D' },
                { hash: '29AC0C1505EE7E5DB5F1E1928712A7DAC0B1623C9D9A2160FD905EE49D850B7D' },
                { hash: 'F6FD6B99B65043B433518979F25367024979DB8F4568BE24D5F867E8EFB50B7D' },
                { hash: '3DF0643A6ADF8BAA63BC7C3DF4A38BDC8B17B02B51FF05609DE6A4871DB2377D' },
                { hash: '397B380A672D03DD21B6E61641E40DE59743739CB4B20111EE63635A893A157D' },
                { hash: 'B9926B349698640963E451BA8D02D7A97B6D266971D2312DED6FC6B30EF1D57D' },
                { hash: '14855B331CCAAF16B8929E4DEAB7C76D3EA6BE340AAFE301FDC32756AA1D677D' },
                { hash: '5FF0819919838EB0924144419DA9E9CE5E57030FC9332EE35110A1D182D2E47D' },
                { hash: 'A7018A1D229669A2602B75F1EFC4C5C6B812A45294E2D5E2F1EE735E4219D07D' },
                { hash: '067754AD11C2B48AB06CED3CBEB06DE8F7D1C6368F1D961CC562DA3B310B837D' },
                { hash: '82C4089930C52B2E45677A92252180629EAE9731D95EEE3A312B1F82CDF6037D' },
                { hash: 'D01542BF8F42A94370E8B70E8FF7BEAE6E3C38F0F530DD2B280F9CBDAFCCC27D' },
                { hash: '2CFCAF1BAD5A9043FE079CD8D3FB6590B7B338754110793D6E9E90653E9AD27D' },
                { hash: '9487BD8B4267F2553C48D01FAAFB15B7685E69AEFD9947201737462DAF67047D' },
                { hash: 'B6CBAA0F1D5EAFA65270AABBAB55C83B8853E43379DACA2AAFCA02993077CF7D' },
                { hash: '3A905C4DF1546F05AADB71913B34FB82C416F72F63C80E82F9A54FA75E0F3A7D' },
                { hash: '3850C2E2E512F46724117F2E2E32C6A67ADCCE3EA27BEBD6962696552986E17D' },
                { hash: '5DEC6309FA7D4767E2F20B3C9919DD65851E498A607F95A3AD2695853664607D' },
                { hash: '1E0D009507AFDF0744BC66DDCC9012A384EF96DDB59A158AD1EF8B992F85747D' },
                { hash: 'B54D4EAFED14899C42D4496A4CEA3CAD03E8182DFE56789B88303075C2B9BA7D' },
                { hash: 'E08FF9E5A3BEBC4B2B4E1D96F2D7F1403E088171F3C57219A7FB0083B8850C7D' },
                { hash: '75B8CDD3D5C9A30F95FDF379F961ABBB32197A3A382F82686972643DA0E89D7D' },
                { hash: 'A4E7A6430DEBDE9C2335FDE4F333B091EBEE3D92928293AD613F70FDCD39D87D' },
                { hash: 'E3F5FB61F732CF9856B08037740CB1ADCE397185003E320308A93630A8F7777D' },
                { hash: '5D1F33D5CC95639CA2478F49FDD6744B771DA224D7FB0A8E9AEC94C1032FBE7D' },
                { hash: 'A33034BEFF8E4B086CA63ACD83A6306CD2B728238CE435F8344A5D3E75E72C7D' },
                { hash: 'BA7D1AD459F9B454E494A43E2040B3FCF4C436E07CDCE21D861C4A079149B77D' },
                { hash: 'FFA3A05D87962005F69A44D99005E3BCA4677CF57CC5A36EF60FDC4E92C7777D' },
                { hash: '2A27A4F320EBDDDED3CCAC82F7A7311A875C16AC72BD3CF342691F013907F07D' },
                { hash: '23DDCE1B947C383502FECA81D9C04F8347237DDBBC6C87109B5FAF98BC206B7D' },
                { hash: 'F90069ED81837CE723F29924A76E80FD65ECFE54EFCA6B45FC5A89B960781A7D' },
                { hash: '33DEAB69DACC96EC21DE97AECEED9F3F0EAC47D45F46D1C00FDD9782C79D017D' },
                { hash: '83BF71443EBD3BFA08B3CFFA3F9A8DCBE01209807AD757A17B3B5FABBE58A77D' },
                { hash: '8A9C213FFD33969C56269E37DDE3EC3D2A90E457D92AB6E07979B88FE2550B7D' },
                { hash: '70D11DA7057A2959E29BD06C6241DB3219B9AA8EE1912B0B73A0657596AB3C7D' },
                { hash: '2E3705A5277DC81EF8A09F516C0A68667F26A75A28BE302E10A9B34DF3C22E7D' },
                { hash: '6CDE7E3F34823BF01DCE29F5DF9D8A4A98902B9D8AF1D5A9F7BBDAE05B39467D' },
                { hash: '401FE79003EDE84ADFAC7B6ECF446159099899B596FFBAF2CA1E0DC01F8F7A7D' },
                { hash: 'D089B0D88D562FC1797EEFB3B5E31D3893B705A83F98BC18E3813BCA1FEFE67D' },
                { hash: '9898D8BB23B08D1B6DB5303193B64D59A8CEF45C707685D90029DBE3EA1BAE7D' },
                { hash: 'AEFAC2B5FCC8087369EBD771883A00CA67F25A22C86F7DAEC13C8F09C4DC387D' },
                { hash: 'F683CEC6AC69E0881ED5F0F03168D0253CC2E61AA5A0C019D1EB17F5EE2CD17D' },
                { hash: '6EEBB1C4D3B4A31C1D1EF5185D4FCA1141C9B72CCE10DCFC6CB7A6328DBAF47D' },
                { hash: '4B6D7E5AAE80A19EB6AD4EC4ED7B5C587DA5CAEEF78D0B1665BDD5A146A1E17D' },
                { hash: '606E84A33DB1AE06F7EC16CE4C7B7A98ACB8417A66B79B33FB4208A066D3E07D' },
                { hash: '74F37DE0E544296C4011FC6A8CEA6196ADD05B0419DE376FD56CA96DD686437D' },
                { hash: 'D04FA7E45F609179ED6A3C326C7B7C191FBE2894CEB621B548769BEB80D94A7D' },
                { hash: 'D29DEE5E00E8894B4A3EB3A8DA12FA2D4CD9A30B3660C993A1DC3C2E8783FD7D' },
                { hash: '39AA25BAAFDF47722CD61EBBB74DA81DDA1AF5ED794BD42435BDFF701CD25F7D' },
                { hash: '7BD895720FD0FC4BFC181922A07F3D1F6D4E75F8563E8BB16657D26DD5F3AA7D' },
                { hash: 'F8F66A907868CAD7EB6FBCDAB3FF0722378652CEA10BE7E15081E821D4BFA47D' },
                { hash: 'ECF0A0282DE1E2ECE059B18B7235718DC63D2FEC00AB758D206E3CE09D6F8F7D' },
                { hash: '9A0849F4658E69E9E6E2571AA4526240D3C7B8A7C24148329BAC31EC18FB727D' },
                { hash: 'A616C15B9A2F1BB9D6E7275408686C9FF1E7640AC712CA7105C50095436C1F7D' },
                { hash: '073BA0F3E05B2FC0A11E3AEE130DBC4FA1FA318FF333E7F5164AD357E288247D' },
                { hash: '15AA75052615263DBC53113F10E3FF24B19EE0F56DC3CC7A8B13018F9324EA7D' },
                { hash: 'A3AE0B99443CF5F98D227AEC19F7222A9F6AC355262053CAF92847CE758DEC7D' },
                { hash: 'F1195B3FF6D99658F2897E5E532E961EAC5D59569811CEF8E35E7352C050FA7D' },
                { hash: '1E7F20EF9D510741575E771A69A44D9EE9C25BA5DFB7D047120CE5FA7529D57D' },
                { hash: '340DB4D04DAEF0075B3E7C8B70BEB2ACFBB880478D8BF3D3F166E0DC7249DD7D' },
                { hash: 'BE1AAD27DD6A7BB877B4DABA047772D212121AB7EDE409407A4BB02B5EC7667D' }
              ]
            },
            {
              match: '',
              combination: '',
              hash: '',
              pool: '52,500,000',
              tx: '',
              hashs: []
            }
          ]
        }
      ],
      // 当前选中
      checked: 1,
      // 当前表格选中项
      tableChecked: 0
    }
  },
  computed: {
    lucky () {
      return this.luckys[this.checked]
    },
    hashs () {
      return this.luckys[this.checked].tables[this.tableChecked]
    }
  },
  methods: {
    // hash内容处理
    getSubStr (str) {
      let code = this.luckys[this.checked].combination
      // let subStr1 = str.substr(0, 9)
      // let subStr2 = str.substr(str.length - 20, 20 - code.length)
      // let subStr = subStr1 + "......" + subStr2
      let subStr2 = str.substr(0, str.length - code.length)
      return subStr2
    },
    luckyTables (index) {
      this.tableChecked = index
    },
    luckyRound (index) {
      this.checked = index
    },
    // 按钮跳转
    toTradeNPXSEM () {
      // window.open('https://www.binance.org/en/trade/NPXSXEM-89C_BNB')
      window.location.href = 'https://www.binance.org/en/trade/NPXSXEM-89C_BNB'
    }
  }
}
</script>

<style lang="scss" scoped>
@mixin box {
    width: 32px;
    height: 53px;
    line-height: 53px;
    display: block;
    text-align: center;
    font-size: 36px;
    color: #FFFFFF;
    border-radius: 2px;
    margin-right: 2px;
}
.hiddSpan {
    display: block;
}
.comingSoon {
    display: flex;
    justify-content: center;
    align-items: center;
    height: inherit;
    color: rgba(0,0,0,.3);
    font-size: 22px;
}
.codeVal {
    font-size: 13px;
    color: #FFC533;
    font-style: unset;
}
.home {
    height: 100%;
    overflow: hidden;
    section:nth-child(1) {
        position: relative;
        background: linear-gradient(to left, #362020, #0E0A0A);
        padding-bottom: 150px;
        .search {
            position: relative;
            padding-top: 30px;
            .searchInput {
                input {
                    width: calc(100% - 76px);
                    border: 0px;
                    padding: 0 12px;
                    padding-right: 64px;
                    line-height: 22px;
                    height: 41px;
                    border-radius: 4px;
                    font-size: 14px;
                    color: #424242;
                    background: rgba(255, 255, 255, 0.85);
                    transition: background .3s linear;
                }
                .searchValCss {
                    color: #111111;
                    background: rgba(255, 255, 255, 1);
                    transition: background .5s linear;
                }
                ::-webkit-input-placeholder { /* WebKit browsers */
                    color: #424242;
                    font-size: 14px;
                }

                ::-moz-placeholder { /* Mozilla Firefox 19+ */
                    color: #424242;
                    font-size: 14px;
                }

                :-ms-input-placeholder { /* Internet Explorer 10+ */
                    color: #424242;
                    font-size: 14px;
                }
            }
            .searchBtn {
                position: absolute;
                bottom: 0;
                right: 0;
                padding: 0px 20px;
                justify-content: center;
                display: flex;
                align-items: center;
                height: 41px;
                background-color: #FFBA28;
                border-radius: 4px;
                img {
                    width: 20px;
                    height: 20px;
                }
            }
        }
        .bgItem1Img {
            position: absolute;
            top: 0;
            left: 60%;
            pointer-events: none;
            z-index: 0;
            opacity: .7;
        }
        .bgItem2Img {
            position: absolute;
            pointer-events: none;
            top: 0;
            left: 5%;
            z-index: 0;
            opacity: .7;
        }
        .totalLeft {
            z-index: 2;
        }
        .totalRight {
            position: relative;
            width: 40.38%;
            z-index: 2;
            top: 40px;
            img {
                width: 100%;
            }
        }
        header {
            padding-left: 55.5px;
            padding-bottom: 75px;
            padding-top: 38.7px;
            img {
                width: 200px;
                height: 30px;
            }
        }
        .npxsxemCon {
            max-width: 1070px;
            margin: 0 auto;
            .participantsCon {
                position: relative;
                height: 141px;
                border-radius: 8px;
                background: #FFFFFF;
                nav {
                    display: flex;
                    height: 100%;
                    .luckyCombination {
                        width: 50%;
                        display: flex;
                        align-items: center;
                        padding-left: 40px;
                        .combinationImg {
                            width: 54px;
                            height: 54px;
                            margin-right: 18.5px;
                        }
                        div {
                            flex-direction: column;
                        }
                    }
                    .participants {
                        width: 50%;
                        display: flex;
                        align-items: center;
                        .participantsImg {
                            width: 54px;
                            height: 54px;
                            margin-right: 18.5px
                        }
                        div {
                            flex-direction: column;
                        }
                    }
                    p {
                        font-size: 16px;
                        color: #797979;
                    }
                    h4 {
                        font-size: 30px;
                        color: #000000;
                    }
                }
                .waveImg {
                    position: absolute;
                    left: 0;
                    right: 0;
                    bottom: -3px;
                    img {
                        height: 125px;
                        width: 100%;
                        border-radius: 7px;
                    }
                }
            }
            .total {
                max-width: 1070px;
                margin: 0 auto;
                display: flex;
                justify-content: space-between;
                align-items: center;
                padding-bottom: 55px;
                .septTitle {
                    font-weight: bold;
                    font-size: 16px;
                    color: #FFFFFF;
                }
                .totalTitle {
                    color: #838383;
                    font-size: 16px;
                }
                h3 {
                    display: flex;
                    align-items: center;
                    padding-bottom: 18px;
                    font-weight: bold;
                    flex-wrap: wrap;
                    .NPXSXEMTitle {
                        font-size: 65px;
                        color: #FFFFFF;
                        padding-right: 15px;
                    }
                    .luckyTitle {
                        display: flex;
                    }
                    .h3L {
                        @include box;
                        background: #FFBA28;
                    }
                    .h3U {
                        @include box;
                        background: #FF8928;
                    }
                    .h3C {
                        @include box;
                        background: #FF6853;
                    }
                    .h3K {
                        @include box;
                        background: #6F45F8;
                    }
                    .h3Y {
                        @include box;
                        background: #61C5E0;
                    }
                }
                h2 {
                    padding-bottom: 60px;
                    font-weight: bold;
                    display: flex;
                    align-items: center;
                    line-height: 68px;
                    flex-wrap: wrap;
                    .toGrab {
                        font-size: 24px;
                        display: flex;
                        flex-direction: column;
                        span:nth-child(1) {
                            color: #FFBA28;
                            line-height: 24px;
                        }
                        span:nth-child(2) {
                            color: #FFFFFF;
                            line-height: 24px;
                        }
                    }
                    > span:nth-child(1) {
                        font-size: 68px;
                        color: #FFBA28;
                        font-weight: bold;
                        padding-right: 3px;
                    }
                }
            }
        }
    }
    section:nth-child(2) {
        background: #FFECC5;
        padding-bottom: 26px;
        .activityRules {
            position: relative;
            top: -70px;
            max-width: 1070px;
            margin: 0 auto;
            padding-bottom: 26px;
            h3 {
                font-size: 16px;
                color: #9c0303;
                font-weight: bold;
                padding-bottom: 10px;
            }
            .activityRulesText {
                padding: 16px;
                background: #FFE4BB;
                p {
                    font-size: 14px;
                    color: #905757;
                    padding-bottom: 10px;
                    display: flex;
                    letter-spacing: .3px;
                    &:last-child {
                        padding-bottom: 0px;
                    }
                    span {
                        display:inline-block;
                        &:nth-child(1) {
                            flex: none;
                            width: 16px;
                            height: 16px;
                            line-height: 16px;
                            font-size: 12px;
                            background: #FFBA28;
                            text-align: center;
                            border-radius: 4px;
                            margin-right: 13px;
                            color: #FFFFFF;
                        }
                    }
                }
            }
        }
        .informationList {
            max-width: 1070px;
            margin: 0 auto;
            display: flex;
            position: relative;
            top: -120px;
            .informationListL {
                // overflow: hidden;
                // overflow-x: auto;
                width:65%;
                background: #FFFFFF;
                border-radius: 8px;
                margin-right: 30px;
                box-shadow: 0px 18px 28px -17px rgba(255, 121, 25, 0.2);
                ul {
                    padding-left: 26px;
                    padding-right: 26px;
                    padding-bottom: 42px;
                    li {
                        line-height: 37px;
                        height: 37px;
                        font-size: 14px;
                        color: #424242;
                        width: 100%;
                        display: flex;
                        border-bottom: .5px solid rgba(234, 234, 234, 0.84);
                        list-style: none;
                        &:hover {
                            background: #f7f7f7;
                            border-radius: 4px;
                        }
                        &:last-child:hover {
                            background: transparent
                        }
                        &.selected {
                            &:hover {
                            background: rgba(255, 186, 40, 0.9);
                            border-radius: 4px;
                        }
                        }
                        span {
                            width: 24%;
                            display: block;
                            padding-left: 15px;
                            &:nth-child(1) {
                                width: 13%;
                            }
                            &:nth-child(2) {
                                color: #FFC533;
                                font-weight: bold;
                                font-style:italic;
                            }
                            &:nth-child(5) {
                                font-weight: bold;
                            }
                        }
                    }
                }
            }
            .informationListR {
                width:35%;
                background: #FFFFFF;
                border-radius: 8px;
                box-shadow: 0px 18px 28px -17px rgba(255, 121, 25, 0.2);
                ul {
                    padding: 18px 40px;
                    overflow: auto;
                    height: 323px;
                    overflow-y: auto;
                    li {
                        list-style: none;
                        text-align: center;
                        // color: rgba(0,0,0,.3);
                        // padding-top: 100px;
                        // font-size: 22px;
                        span {
                            /*overflow: hidden;*/
                            background: #F3F3F3;
                            padding: 5px 3px;
                            font-size: 13px;
                            color: #424242;
                            letter-spacing: -0px;
                            margin-bottom: 8px;
                            display: block;
                            border-radius: 4px;
                            text-align: left;
                            word-wrap: break-word;
                            word-break: normal;
                        }
                    }
                }
            }
            .informationListTitle {
                padding-left: 26px;
                padding-right: 26px;
                padding-top: 20px;
                padding-bottom: 20px;
                font-size: 14px;
                color: #00042D;
                font-weight: bold;
                display: flex;
                border-bottom: .5px solid rgba(0,0,0,0.18);
                span {
                    width: 24%;
                    padding-left: 15px;
                    &:nth-child(1) {
                        width: 13%;
                    }
                }
            }
        }
    }
}

.tradeBtnicon {
    background-image: url('../../assets/img/button_icon_more@2x.png');
    background-repeat: no-repeat;
    background-size: contain;
    background-position: center;
    width: 14px;
    height: 14px;
    margin-left: 28px;
}

.tradeBtn {
    width: 224px;
    padding-bottom: 30px;
}

.selected {
    position: relative;
    background: #FFBA28;
    border-radius: 4px;
    span {
        color: #FFFFFF!important;
    }
    &:before {
        right: -56px;
        content: '';
        display: block;
        border-width: 6px;
        position: absolute;
        bottom: 12px;
        font-size: 0;
        line-height: 0;
        border-style: solid dashed dashed;
        border-color: transparent #FFFFFF transparent transparent;
    }
}

.exampleListTitle {
    padding-left: 26px;
    padding-right: 26px;
    padding-top: 20px;
    padding-bottom: 20px;
    font-size: 14px;
    color: #00042D;
    font-weight: bold;
    display: flex;
    border-bottom: .5px solid rgba(0,0,0,0.18);
    span {
        width: 24%;
        padding-left: 15px;
        &:nth-child(1) {
            width: 13%;
        }
    }
}

.exampleListL {
    width:100%;
    overflow: hidden;
    overflow-x: auto;
    background: #ffd9a0;
    border-radius: 8px;
    margin-right: 30px;
    box-shadow: 0px 18px 28px -17px rgba(255, 121, 25, 0.2);
    ul {
        padding-left: 26px;
        padding-right: 26px;
        padding-bottom: 42px;
        li {
            line-height: 37px;
            height: 37px;
            font-size: 14px;
            color: #424242;
            width: 100%;
            display: flex;
            border-bottom: .5px solid rgba(234, 234, 234, 0.84);
            list-style: none;
            span {
                width: 24%;
                display: block;
                padding-left: 15px;
                &:nth-child(1) {
                    width: 13%;
                }
                &:nth-child(2) {
                    // color: #FFC533;
                    font-weight: bold;
                    font-style:italic;
                }
                &:nth-child(5) {
                    font-weight: bold;
                }
            }
        }
    }
}

.medium {
    text-decoration: underline;
    color: #9e1818;
    font-weight: bold;
    font-style: italic;
}

.commonBtn {
    cursor:pointer;
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
    height: 60px;
    line-height: 60px;
    color: #FFBA28;
    font-weight: bold;
    border: 1px solid #FFBA28;
    border-radius: 8px;
    font-size: 14px;
}

@media screen and (max-width: 1200px) {
    .npxsxemCon, .informationList, .activityRules {
        width: 90%;
    }
    .home {
        section:nth-child(1) {
            .npxsxemCon {
                .total {
                    h3 {
                        > span:nth-child(1) {
                            font-size: 48px;
                        }
                    }
                    h2 {
                        .toGrab {
                            font-size: 18px;
                            span {
                                &:nth-child(1) {
                                    line-height: 18px
                                }
                                &:nth-child(2) {
                                    line-height: 18px
                                }
                            }
                        }
                        > span:nth-child(1) {
                            font-size: 48px;
                        }
                    }
                }
            }
        }
        section:nth-child(2) {
            .informationList {
                .informationListR {
                    ul {
                        padding-left: 26px;
                        padding-right: 26px;
                        li {
                            span {
                                overflow-x: auto;
                            }
                        }
                    }
                }
            }
        }
    }
}

.round-list {
    padding-bottom: 20px;
}
.round {
    display: inline-block;
    padding: 12px 20px;
    border-radius: 30px;
    color: white;
    margin-right: 20px;
    cursor: pointer;
}
.round-active,
.round:hover{
    background-color: #fdf1da;
    color: #000000;
}

@media screen and (max-width: 750px) {
    .selected {
        &:before {
            display: none;
        }
    }
    .hiddSpan {
        display: none!important;
    }
    .home {
        section:nth-child(1) {
            header {
                text-align: center;
                padding-left: 0px;
                padding-bottom: 45px;
                padding-top: 45px;
                img {
                    width: 150px;
                    height: 22.5px;
                }
            }
            .bgItem1Img {
                left: 15%;
                svg {
                    width: 400px;
                    height: 400px;
                }
            }
            .bgItem2Img {
                left: 0;
                svg {
                    width: 200px;
                    height: 200px;
                }
            }
            .npxsxemCon {
                .total {
                    flex-direction: column-reverse;
                    align-items: inherit;
                    h3 {
                        padding-bottom: 30px;
                        .NPXSXEMTitle {
                            font-size: 60px;
                        }
                    }
                    h2 {
                        padding-bottom: 40px;
                        span {
                            line-height: 48px;
                        }
                    }
                }
                .participantsCon {
                    height: auto;
                    nav {
                        display: block;
                        .luckyCombination {
                            padding-top: 26px;
                        }
                        .luckyCombination, .participants {
                            width: auto;
                            padding-left: 28px;
                            padding-right: 28px;
                            padding-bottom: 26px;
                        }
                    }
                }
            }
            .totalRight {
                top: 0;
                width: 77.38%;
                margin: auto;
            }
        }
        section:nth-child(2) {
            .activityRules {
                top: -110px;
            }
            .informationList {
                top: -120px;
                display: block;
                .informationListTitle {
                    font-size: 12px;
                    padding-left: 16px;
                    padding-right: 16px;
                    span {
                        width: 25%;
                        padding-left: 5px;
                    }
                }
                .informationListL, .informationListR {
                    width: 100%;
                }
                .informationListL {
                    ul {
                        padding-left: 16px;
                        padding-right: 16px;
                        li span{
                            width: 25%;
                            padding-left: 5px;
                        }
                    }
                }
                .informationListR {
                    margin-top: 20px;
                    .informationListTitle {
                        position: relative;
                        &:before {
                            left: calc(50% - 6px);
                            top: -12px;
                            content: '';
                            display: block;
                            border-width: 6px;
                            position: absolute;
                            font-size: 0;
                            line-height: 0;
                            border-style: solid dashed dashed;
                            border-color: transparent  transparent #FFFFFF;
                        }
                    }
                    ul {
                        padding-left: 16px;
                        padding-right: 16px;
                        li {
                        // padding-bottom: 100px;
                        }
                    }
                }
            }
        }
    }
    .exampleListTitle {
        font-size: 12px;
        padding-left: 16px;
        padding-right: 16px;
        span {
            width: 25%;
            padding-left: 5px;
        }
    }
    .exampleListL {
        ul {
            padding-left: 16px;
            padding-right: 16px;
            li {
                span {
                    width: 25%;
                    padding-left: 5px;
                }
            }
        }
    }
    .tradeBtn {
        width: 100%;
    }
    .commonBtn {
        font-size: 16px;
    }
}
</style>
